import strings from 'owa-strings/owa-mail-strings';
export var FilePickerViewType;
(function (FilePickerViewType) {
    FilePickerViewType[FilePickerViewType["List"] = 0] = "List";
    FilePickerViewType[FilePickerViewType["Tile"] = 1] = "Tile";
})(FilePickerViewType || (FilePickerViewType = {}));
// Used for ariaLabel and title (hover tooltip) of viewSwitcher icon.
export var viewTypeDisplayStrings = (_a = {},
    _a[FilePickerViewType.List] = function () { return strings.ViewSwitcherListView_TitleText; },
    _a[FilePickerViewType.Tile] = function () { return strings.ViewSwitcherTileView_TitleText; },
    _a);
var _a;
//# sourceMappingURL=FilePickerViewSwitcher.js.map